"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useLDPayload = require("./useLDPayload");
Object.keys(_useLDPayload).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useLDPayload[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useLDPayload[key];
    }
  });
});